module.exports = __webpack_public_path__ + "assets/icon-upload.37a09009.svg";